import {IRole, ISession} from "@/types/auth-data";


export class Session implements ISession {
    constructor() {
        this.fromJson(localStorage.getItem("session"))

    }
    get role(): IRole | null {
        return this._role;
    }

    set role(value: IRole | null) {
        this._role = value;
    }

    get exp(): number | null {
        return this._exp;
    }

    set exp(value: number | null) {
        this._exp = value;
    }

    setItemSession(session: string | null): this {
        if (!session) {
            localStorage.removeItem('session');
            this.role = this.exp = null;
            return this;
        }
        localStorage.setItem("session", session);
        return this.fromJson(session);
    }

    fromJson(jsonString: string | null): this {
        if (!jsonString) {
            return this;
        }
        try {
            const {exp, role} = JSON.parse(jsonString);
            this.exp = Number(exp) || null;
            this.role = <IRole>Object.values(IRole).find(r => r === role) || null;
        } catch (e) {
            console.log(e)
        }
        return this;
    }

    private _exp: number | null = null;
    private _role: IRole | null = null;
}

export default Session;